import { Checkbox, Column } from "best-common-react";
import React from "react";
import { ActionProps } from "./ActionHandler";

const RequestSentToClubAction: React.FC<ActionProps> = ({ state, onStateChange }) => (
  <Column width={2} className="bcr-mt-4">
    <Checkbox
      id="request-sent-to-club"
      label="Request Sent to Club"
      checked={!!state.requestSentToClub}
      onChange={() => {
        onStateChange({ ...state, requestSentToClub: !state.requestSentToClub });
      }}
    />
  </Column>
);

export default RequestSentToClubAction;
